import { render, staticRenderFns } from "./regenerate-recovery-code-action-drawer.vue?vue&type=template&id=7fbbef23&"
import script from "./regenerate-recovery-code-action-drawer.vue?vue&type=script&lang=js&"
export * from "./regenerate-recovery-code-action-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports